module.exports = __webpack_public_path__ + "img/om7_tnb.01250a0e.jpg";